/** @jsx jsx */

import { ComponentProps, Fragment } from 'react';

import { jsx } from '@emotion/core';

import NavLink from './NavLink';

const navCss = {
  display: 'none',
  ul: {
    margin: 0,
    padding: 0,
  },
  '@media (min-width: 1079px)': {
    display: 'flex',
    alignSelf: 'stretch',
    alignItems: 'center',
    borderLeft: '1px solid rgba(255, 255, 255, 0.1)',
    padding: '0 12px',
    ul: {
      display: 'flex',
    },
    li: {
      listStyle: 'none',
      display: 'block',
      margin: '0 12px',
    },
  },
};

type Props = {
  links: ComponentProps<typeof NavLink>[];
};

function CtaLinks({ links }: Props) {
  return (
    <Fragment>
      <nav aria-label="CTA navigation" css={navCss}>
        <ul>
          {links.map(link => (
            <li key={link.label}>
              <NavLink
                href={link.href}
                isActive={link.isActive}
                label={link.label}
                onClick={link.onClick}
              />
            </li>
          ))}
        </ul>
      </nav>
    </Fragment>
  );
}

CtaLinks.defaultProps = {
  links: [],
};
export default CtaLinks;
